import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';
import { GRAPHQL_ENDPOINT } from './constants';

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: new HttpLink({
    uri: GRAPHQL_ENDPOINT,
    fetchOptions: {
      cache: 'no-store',
    },
  }),
});

export default client;
